import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgHiOutlineLayers({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<g clipPath="url(#clip0_13307_52936)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M7.71554 0.971719C7.89313 0.876096 8.10688 0.876096 8.28446 0.971719L14.7845 4.47172C14.9788 4.57637 15.1 4.77927 15.1 5C15.1 5.22073 14.9788 5.42364 14.7845 5.52828L12.9798 6.5L14.7845 7.47172C14.9788 7.57637 15.1 7.77927 15.1 8C15.1 8.22073 14.9788 8.42364 14.7845 8.52828L12.9798 9.5L14.7845 10.4717C14.9788 10.5764 15.1 10.7793 15.1 11C15.1 11.2207 14.9788 11.4236 14.7845 11.5283L8.28446 15.0283C8.10688 15.1239 7.89313 15.1239 7.71554 15.0283L1.21554 11.5283C1.0212 11.4236 0.900002 11.2207 0.900002 11C0.900002 10.7793 1.0212 10.5764 1.21554 10.4717L3.02016 9.5L1.21554 8.52828C1.0212 8.42364 0.900002 8.22073 0.900002 8C0.900002 7.77927 1.0212 7.57637 1.21554 7.47172L3.02016 6.5L1.21554 5.52828C1.0212 5.42364 0.900002 5.22073 0.900002 5C0.900002 4.77927 1.0212 4.57637 1.21554 4.47172L7.71554 0.971719ZM4.28572 7.18145L2.76556 8L8 10.8185L13.2344 8L11.7143 7.18145L8.28446 9.02828C8.10688 9.12391 7.89313 9.12391 7.71554 9.02828L4.28572 7.18145ZM4.28572 10.1815L2.76556 11L8 13.8185L13.2344 11L11.7143 10.1815L8.28446 12.0283C8.10688 12.1239 7.89313 12.1239 7.71554 12.0283L4.28572 10.1815ZM2.76556 5L8 7.81855L13.2344 5L8 2.18146L2.76556 5Z"
					fill={finalColor}
				/>
			</g>
			<defs>
				<clipPath id="clip0_13307_52936">
					<rect width={16} height={16} fill={finalColor} />
				</clipPath>
			</defs>
		</svg>
	);
}
export default SvgHiOutlineLayers;
